const steps = [
  ["01", "Pre-register", "Invite the visitor before they arrive."],
  ["02", "Verify", "Confirm the invitation at the door."],
  ["03", "Approve", "An allowed person accepts the visit."],
  ["04", "Check in", "The kiosk records arrival and a badge."],
  ["05", "Control", "The visitor stays for the approved time."],
  ["06", "Check out", "Exit closes the visit and the badge."],
];

function Flow({ items }) {
  return (
    <ol className="grid items-start gap-6 md:grid-cols-[1fr_auto_1fr_auto_1fr] md:gap-4">
      {items.map(([number, title, copy], index) => (
        <li key={number} className="contents">
          <div>
            <p className={`text-3xl font-extrabold tracking-tight ${index % 2 ? "text-brand-orange" : "text-brand-blue"}`}>{number}</p>
            <h3 className="mt-2 text-lg font-bold">{title}</h3>
            <p className="mt-1 text-sm leading-6 text-slate-600">{copy}</p>
          </div>
          {index < items.length - 1 ? (
            <span className="hidden pt-3 text-xl text-slate-300 md:block" aria-hidden="true">→</span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}

export function VisitorLifecycle() {
  return (
    <section id="lifecycle" className="scroll-mt-20 px-5 py-20">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="text-4xl font-extrabold tracking-tight">The visitor lifecycle</h2>
            <p className="mt-3 text-slate-600">A complete, secure and auditable process from invitation to exit.</p>
          </div>
          <a href="#overview" className="font-semibold text-brand-blue">See the product →</a>
        </div>
        <div className="mt-14 space-y-10">
          <Flow items={steps.slice(0, 3)} />
          <Flow items={steps.slice(3)} />
        </div>
      </div>
    </section>
  );
}
